import { ChangeDetectionStrategy, Component, input, model, ViewEncapsulation } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
@Component({
    selector: "app-cerrix-checkbox",
    imports: [MatIconModule],
    templateUrl: "./cerrix-checkbox.component.html",
    styleUrl: "./cerrix-checkbox.component.scss",
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CerrixCheckboxComponent {
    readonly disabled = input<boolean>(false);
    readonly required = input<boolean>(false);
    readonly name = input<string>("");
    readonly value = model<boolean>(false);
    readonly indeterminate = model<boolean>(false);

    protected toggle(): void {
        this.value.update((checked) => !checked);
        this.indeterminate.set(false);
    }
}
